import { notNullish } from "@de-xima/xima-common-js-lang";
import type { IOpenedWindow } from "./Header.ts";
import $ from "jquery";

const windows = new Map<string, Window>();

function closeAllOpenWindows() {
  for (const win of windows.values()) {
    try {
      if (!win.closed) {
        win.close();
      }
    } catch {
      // ignore, already closed etc.
    }
  }
  return undefined;
}

/**
 * Opens a new window and returns an ID for the window. Can be used to refer to
 * that window later on.
 * @param url URL for the window.
 * @param target Target frame.
 * @param features Optional features for the window.
 * @returns The opened window and a unique serializable ID to refer to that
 * window later on.
 */
export function openWindow(url: string, target: string, features?: string): IOpenedWindow {
  const existingWindow = windows.get(target);
  if (existingWindow !== undefined) {
    if (!existingWindow.closed) {
      return { new: false, window: existingWindow, windowId: target };
    }
    windows.delete(target);
  }
  const newWin = window.open(url, target, features);
  if (notNullish(newWin)) {
    windows.set(target, newWin);
    return { new: true, window: newWin, windowId: target };
  }
  return { new: false, window: undefined, windowId: "" };
}

export function initWindowManager(): void {
  // Close all child windows we opened when parent window closes
  $(window).on("beforeunload", closeAllOpenWindows);
}
